module.exports = __webpack_public_path__ + "static/oceanit-honolulu-019e4b2e168511684443afb7965bc898.jpg";